<template>
  <article class="show-teaser">
    <NuxtLink :to="show.path.alias" class="show-teaser__inner">
      <div class="show-teaser__cover">
        <ResponsiveImage v-if="show.image" :image="show.image" />
        <PlaceholderImage v-else />
      </div>
      <h3 class="show-teaser__heading">
        {{ show.title }}
      </h3>
      <div v-if="show.tags.length" class="show-teaser__tags">
        <div v-for="(tag) in show.tags" :key="`show-teaser__tag--${tag.uuid}`" class="show-teaser__tag">
          {{ tag.label }}
        </div>
      </div>
    </NuxtLink>
  </article>
</template>

<script setup lang="ts">
import { type ShowTeaserFragment } from '#graphql-operations'

defineProps<{
  show: ShowTeaserFragment
}>()

</script>

<style lang="scss" scoped>
@use "~/assets/sass/tools";

.show-teaser {
  &__inner {
    text-decoration: none;
  }

  &__cover {
    @include tools.square-image-crop;
  }

  &__heading {
    margin-top: var(--space--s);
    margin-bottom: 0;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space--s);
    margin-top: var(--space--sm);
  }

  &__tag {
    @include tools.tag-big;
  }
}
</style>
